import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { IconBrandTelegram } from "@tabler/icons-react";
import { getTelegramWebApp } from "@/shared/lib/telegram";
import { appConfig } from "@/shared/config";
import styles from "./TelegramStartGate.module.scss";
/** Telegram-юзернейм нашей поддержки. Без `@` — добавляется в UI отдельно. */
const SUPPORT_USERNAME = "virtuos_help_bot";
const SUPPORT_TG_URL = appConfig.supportBots.telegram;
const WEB_BROWSER_URL = "https://app.virtuoz.pro";
const WEB_BROWSER_LABEL = "app.virtuoz.pro";
/**
 * Открыть ссылку на Telegram-чат. Внутри TG WebApp используем
 * `openTelegramLink` — это правильный способ, бесшовно открывает чат
 * прямо в Telegram. Если по какой-то причине метод недоступен —
 * fallback на обычный `window.open`.
 */
function openTelegramChat(url) {
    const webApp = getTelegramWebApp();
    if (webApp?.openTelegramLink) {
        try {
            webApp.openTelegramLink(url);
            return;
        }
        catch {
            /* fall through */
        }
    }
    window.open(url, "_blank", "noopener,noreferrer");
}
/**
 * Открыть внешнюю ссылку «наружу» из TG WebApp. `openLink` запускает
 * системный браузер, что нам и нужно для app.virtuoz.pro.
 */
function openExternalLink(url) {
    const webApp = getTelegramWebApp();
    if (webApp?.openLink) {
        try {
            webApp.openLink(url);
            return;
        }
        catch {
            /* fall through */
        }
    }
    window.open(url, "_blank", "noopener,noreferrer");
}
/**
 * Заглушка для случая, когда мы запущены внутри Telegram WebApp, отправили
 * `initData` на бэкенд, и авторизация по какой-то причине не прошла
 * (404 — нет в БД / не нажат /start, либо 401/5xx/network и т.п.).
 *
 * В TG нет email-флоу, поэтому показывать MiniApp с модалкой входа
 * бессмысленно — пользователь зависнет. Вместо этого показываем
 * инструкцию: нажать /start в боте, либо написать в поддержку.
 *
 * Никакой логики авторизации тут нет — это чисто статический экран.
 * Решение «показывать его или нет» принимает App.tsx по флагу
 * `telegramAuthFailed` из AuthContext.
 */
export const TelegramStartGate = ({ language, }) => {
    const isRu = language === "ru";
    const handleSupportClick = (e) => {
        e.preventDefault();
        openTelegramChat(SUPPORT_TG_URL);
    };
    const handleBrowserClick = (e) => {
        e.preventDefault();
        openExternalLink(WEB_BROWSER_URL);
    };
    return (_jsx("div", { className: styles.root, children: _jsxs("div", { className: styles.card, children: [_jsx("div", { className: styles.iconWrap, "aria-hidden": "true", children: _jsx(IconBrandTelegram, { size: 32 }) }), _jsx("h1", { className: styles.title, children: isRu
                        ? "Нажмите /start в боте"
                        : "Press /start in the bot" }), _jsx("span", { className: styles.command, "aria-hidden": "true", children: "/start" }), _jsx("p", { className: styles.helper, children: isRu ? (_jsxs(_Fragment, { children: ["\u0415\u0441\u043B\u0438 \u0432\u044B \u0443\u0436\u0435 \u043D\u0430\u0436\u0438\u043C\u0430\u043B\u0438", " ", _jsx("span", { className: styles.helperEmphasis, children: "/start" }), " \u0438 \u0432\u0438\u0434\u0438\u0442\u0435 \u044D\u0442\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u2014 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443 \u0432 Telegram:", " ", _jsxs("a", { className: styles.supportLink, href: SUPPORT_TG_URL, onClick: handleSupportClick, target: "_blank", rel: "noopener noreferrer", children: [_jsx(IconBrandTelegram, { size: 14, className: styles.supportIcon, "aria-hidden": "true" }), "@", SUPPORT_USERNAME] }), ". \u0412\u044B \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043D\u0430\u0448\u0438\u043C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0435", " ", _jsx("a", { className: styles.browserLink, href: WEB_BROWSER_URL, onClick: handleBrowserClick, target: "_blank", rel: "noopener noreferrer", children: WEB_BROWSER_LABEL }), "."] })) : (_jsxs(_Fragment, { children: ["If you have already pressed", " ", _jsx("span", { className: styles.helperEmphasis, children: "/start" }), " and still see this page, message our support on Telegram:", " ", _jsxs("a", { className: styles.supportLink, href: SUPPORT_TG_URL, onClick: handleSupportClick, target: "_blank", rel: "noopener noreferrer", children: [_jsx(IconBrandTelegram, { size: 14, className: styles.supportIcon, "aria-hidden": "true" }), "@", SUPPORT_USERNAME] }), ". You can also use our app in the browser at", " ", _jsx("a", { className: styles.browserLink, href: WEB_BROWSER_URL, onClick: handleBrowserClick, target: "_blank", rel: "noopener noreferrer", children: WEB_BROWSER_LABEL }), "."] })) })] }) }));
};
export default TelegramStartGate;
